const truncateString = (inputString, index) => {
  if (inputString.length <= index) {
    return inputString;
  }

  // Extract the substring up to the specified index
  const truncatedSubstring = inputString.substring(0, index);

  // Add the ellipsis (...) to indicate that the string has been truncated
  const truncatedString = `${truncatedSubstring}...`;

  return truncatedString;
};

const cleanAndCompareNames = (name1, name2) => {
  // Remove spaces and non-alphanumeric characters, and convert to lowercase
  const cleanName1 = name1.replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
  const cleanName2 = name2.replace(/[^a-zA-Z0-9]/g, '').toLowerCase();

  // Compare the cleaned names
  return cleanName1 === cleanName2;
};

export { truncateString, cleanAndCompareNames };
